const comments = [
  {
    id: 1,
    author: '吃瓜第一线',
    avatar: 'C',
    avatarBg: 'bg-primary-500',
    date: '2小时前',
    content: '暴走黑料这个系列太顶了！整理得又全又快，比我自己一个个去搜方便太多了。七月娱乐圈大地震那篇看得我直呼好家伙，信息量爆炸！',
    likes: 328,
    tag: '暴走黑料铁粉',
  },
  {
    id: 2,
    author: '八卦研究员',
    avatar: '八',
    avatarBg: 'bg-accent-500',
    date: '5小时前',
    content: '黑料社的深度分析是真的牛，每期都像在看调查报告一样。特别是艺人片酬那篇，数据给得很详细，逻辑也清楚，作为业内人士都挑不出毛病。',
    likes: 256,
    tag: '黑料社粉丝',
  },
  {
    id: 3,
    author: '深夜追瓜人',
    avatar: '夜',
    avatarBg: 'bg-secondary-500',
    date: '8小时前',
    content: '每天下班第一件事就是来黑料在线看看更新没有。说实话现在网上垃圾信息太多了，像你们这样认真做整理的平台真的不多了，保持住！',
    likes: 189,
    tag: '每日打卡',
  },
  {
    id: 4,
    author: '理性吃瓜群众',
    avatar: '理',
    avatarBg: 'bg-primary-500',
    date: '12小时前',
    content: '建议多做一些时间线的整理，有些瓜时间跨度长容易被带节奏。黑料社那种深度分析的模式挺好的，期待更多类似的系列内容。',
    likes: 142,
    tag: '老用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            读者热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            吃瓜群众对暴走黑料与黑料社的真实评价
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${comment.avatarBg} text-background-50 text-sm font-bold flex-shrink-0`}>
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{comment.author}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-500/10 text-primary-400 whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 mt-4 pt-3 border-t border-background-200/40">
                <span className="flex items-center gap-1.5 text-xs text-foreground-400 cursor-pointer hover:text-accent-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
                <span className="flex items-center gap-1.5 text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors">
                  <i className="ri-share-forward-line"></i>
                  分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}